import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { contactUs } from "../../../state/actions/customers/customers";

export default function ContactUsForm(props) {
    const formikRef = useRef();
    const dispatch = useDispatch();

    const [formSubmitted, setformSubmitted] = useState(false);
    
    const customersReducer = useSelector((state) => state.customersReducer);

    // <---------------------------------------- form ---------------------------------------->
    // on submit success reset form
    useEffect(() => {
        if (!customersReducer.contactUsLoading && formSubmitted) {
            if (customersReducer.contactUsFailed) {
                setformSubmitted(false);
            } else {
                //
                formikRef.current.resetForm();
            }
        }
    }, [customersReducer.contactUsLoading]);

    // handle submit
    function handleFormSubmit(values) {
        console.log(values);
        dispatch(contactUs(values.name, values.email, values.message));
        setformSubmitted(true);
    }
    //

    const FormSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Required"),
        name: Yup.string().required("Required"),
        message: Yup.string().required("Required"),
    });
    //

    return (
        <>
            {/* <--------------------------------------------------------- form ---------------------------------------------------------> */}
            <div className="flex-fill pr-lg-2">
                <Formik
                    validationSchema={FormSchema}
                    onSubmit={handleFormSubmit}
                    initialValues={{
                        email: "",
                        message: "",
                        name: "",
                    }}
                    innerRef={formikRef}
                    validateOnChange={false}
                    validateOnBlur={true}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        isSubmitting,
                    }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                            className="my-4"
                        >
                            {/* Error message */}
                            {Object.keys(errors).length > 0 && (
                                <p className="text-danger">
                                    Please correct the errors below and attempt
                                    resubmitting the form.
                                </p>
                            )}

                            {/* Name  */}
                            <Form.Group controlId="validation.contactUs.name">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    className="form-control"
                                    disabled={customersReducer.contactUsLoading}
                                    type="name"
                                    // placeholder="Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    isInvalid={!!errors.name}
                                    isValid={
                                        !props.loginAttemptFailed &&
                                        touched.name &&
                                        !errors.name
                                    }
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Email  */}
                            <Form.Group controlId="validation.contactUs.email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className="form-control"
                                    disabled={customersReducer.contactUsLoading}
                                    type="email"
                                    // placeholder="Email"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    isInvalid={!!errors.email}
                                    isValid={
                                        !props.loginAttemptFailed &&
                                        touched.email &&
                                        !errors.email
                                    }
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            {/* <-----------------------------> */}

                            {/* Message  */}
                            <Form.Group controlId="validation.contactUs.message">
                                <Form.Label>Message</Form.Label>
                                <Form.Control
                                    className="form-control"
                                    disabled={customersReducer.contactUsLoading}
                                    type="message"
                                    // placeholder="Message"
                                    name="message"
                                    value={values.message}
                                    onChange={handleChange}
                                    isInvalid={!!errors.message}
                                    isValid={
                                        !props.loginAttemptFailed &&
                                        touched.message &&
                                        !errors.message
                                    }
                                    as="textarea"
                                    rows={4}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                            {/* <-----------------------------> */}

                            {/* <-----------------------------> */}
                            <Button
                                type="submit"
                                className="analytics-contact-us-form-button-submit btn btn btn-primary"
                                disabled={customersReducer.contactUsLoading}
                            >
                                {customersReducer.contactUsLoading
                                    ? "Loading..."
                                    : "Send"}
                            </Button>
                        </Form>
                    )}
                </Formik>
            </div>
            {/* <--------------------------------------------------------- end form ---------------------------------------------------------> */}
        </>
    );
}
